module.exports = __webpack_public_path__ + "img/size_1_2.0787db04.png";